import React from 'react';
const LoaderAddProduct = 'https://s3.emmezeta.hr/falcon/loaderAddProduct.gif';
const HeartFillIcon = 'https://s3.emmezeta.hr/falcon/heart-fill.svg';
const HeartIcon = 'https://s3.emmezeta.hr/falcon/heart.svg';
import { useProduct } from '../../../context/ProductContext';
import useWishlist from '../../../hooks/useWishlist';
import {useUserContext} from "../../../context/UserContext";

const AddToWishlist = () => {
  const {wishlist} = useUserContext()

  const product = useProduct();
  // Bezpieczne pobieranie właściwości
  const sku = product?.sku || '';
  const name = product?.name || '';
  
  // Opcjonalnie dodajemy cenę jeśli jest dostępna
  const price = product?.prices && Array.isArray(product.prices) && product.prices.length > 0 
    ? product.prices[0].amount 
    : null;

  const { toggleInWishlist, loading, isInWishlist } = useWishlist(sku, name, null, price);

  // Nie renderuj komponentu, jeśli nie ma produktu
  if (!sku) {
    return null;
  }
  return (
    <div className="add-to-wishlist">
      <a className="product-gallery__favorite-link" onClick={(e) => {
        e.preventDefault();
        toggleInWishlist(e);
      }}>
        {!loading && <img loading="lazy" src={isInWishlist ? HeartFillIcon : HeartIcon} alt="" style={{ width: 25 }} />}
        {loading && <img loading="lazy" src={LoaderAddProduct} alt="" />}
      </a>
    </div>
  );
};

export default React.memo(AddToWishlist);
